import { defineStore } from 'pinia'
import { ref } from 'vue'

type ConferenceUpdatedHandler = (event: {
  pServed: string
  extendedParams?: { publicIdentity?: string }
}) => void

export const useRoomPublicIdentityStore = defineStore('room-public-identity', () => {
  const publicIdentityByPServedMap = ref(new Map<string, string>())
  const pServedsByPublicIdentities = ref(new Map<string, string>())
  let isSubscriptionStarted = false

  const applyConferenceUpdated: ConferenceUpdatedHandler = (event) => {
    const { pServed } = event
    const publicIdentity = event.extendedParams?.publicIdentity
    if (publicIdentity) {
      const oldIdentity = publicIdentityByPServedMap.value.get(pServed)
      if (oldIdentity) {
        pServedsByPublicIdentities.value.delete(oldIdentity)
      }
      pServedsByPublicIdentities.value.set(publicIdentity, pServed)

      publicIdentityByPServedMap.value.set(pServed, publicIdentity)
    } else {
      const oldIdentity = publicIdentityByPServedMap.value.get(pServed)
      if (oldIdentity) {
        pServedsByPublicIdentities.value.delete(oldIdentity)
      }

      publicIdentityByPServedMap.value.delete(pServed)
    }
  }

  const ensureImSubscription = () => {
    if (isSubscriptionStarted) return
    isSubscriptionStarted = true
    void import('@wui/im').then(({ useIM }) => {
      const { onConferenceUpdated } = useIM()
      onConferenceUpdated(applyConferenceUpdated)
    }).catch((error: unknown) => {
      isSubscriptionStarted = false
      console.warn('Failed to subscribe room public identity to IM', error)
    })
  }

  ensureImSubscription()

  const getPublicIdentity = (pServed: string): string | undefined => {
    ensureImSubscription()
    return publicIdentityByPServedMap.value.get(pServed)
  }

  const getPServedByIdentity = (identity: string): string | undefined => {
    ensureImSubscription()
    return pServedsByPublicIdentities.value.get(identity)
  }

  return {
    getPublicIdentity,
    getPServedByIdentity,
  }
})
